// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c8Xf","title":"styles_title__1wQ0v"};